import type { ItemVariation } from '@kimuno/api-sdk/lib/types/responses/Collection';

import type { ContentItem } from '../types/AppContent';
import type { StoreType } from './index';

export const getContent = (
	type: ItemVariation,
	id: string,
	mindItems: StoreType['mindItems']['byId'],
	products: StoreType['products']['byId']
): ContentItem | undefined => {
	if (type === 'mindItem') {
		const mindItem = mindItems[id];
		return (
			mindItem &&
			mindItem.data && {
				...mindItem.data,
				type: 'mindItem',
			}
		);
	}
	const product = products[id];
	return (
		product &&
		product.data && {
			...product.data,
			type: 'product',
		}
	);
};
